import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./home.css";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import axios from "axios";
import { useEffect, useState } from "react";
import { Footer } from "../Components/footer";
import { LoadingSpinner } from "../Components/loading";
import {
  BalloonContainer,
  FadeInElement,
  ZoomInElement,
} from "../Components/animations";
import MapComponent from "../Components/MapComponent";
import { BASE_URL as api } from "../services";
import { toast } from "react-toastify";
export const Home = ({setTheme,setProfileData,profileData}) => {
  const { name } = useParams();
  const [result, setResult] = useState("  ");
  const [mname, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [bday, setBday] = useState();
  const [bmonth, setBmonth] = useState();

  useEffect(() => {
    profile();
  });

  const profile = async () => {
    try {
      if(profileData?.Username===name){
        setResult(profileData)
        const [, fetchedBmonth, fetchedBday] = profileData?.DOB.split("-");
        setBmonth(fetchedBmonth);
        setBday(fetchedBday);
        setFavicon(profileData?.Photo);
        document.title = profileData?.Name;
        return;
            }
      const response = await axios.post(
        `${api}/port/${name}`
      );

      if (!response.data) {
        window.location.href = "/";
      } else {
        setResult(response.data);
        setProfileData(response.data)
        const [, fetchedBmonth, fetchedBday] = response.data.DOB.split("-");
        setBmonth(fetchedBmonth);
        setBday(fetchedBday);
        setFavicon(response.data.Photo);
        document.title = response.data.Name;
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      // Handle the error here, e.g., show an error message to the user
    } finally {
      // Move setLoading into the finally block to ensure it's called regardless of success or failure
      setLoading(false);
    }
  };

  function setFavicon(url) {
    const faviconLink = document.createElement("link");
    faviconLink.rel = "icon";
    faviconLink.href = url;

    // Remove existing favicon links before appending the new one
    const existingFavicons = document.querySelectorAll("link[rel='icon']");
    existingFavicons.forEach((favicon) => favicon.remove());

    document.head.appendChild(faviconLink);
  }

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const openPdf = (pdfUrl) => {
    // Open the PDF in a new window or tab
    window.open(pdfUrl, "_blank");
  };

  const SendMail = async () => {
    if (email && mname && message) {
      try {
        const response = await axios.post(api + "/sendMail", {
          name,
          message,
          mname,
          email,
          Email:result.Email
        });
  
        if (response.data) {
          toast.success("Email sent successfully.");
          setName("");
          setEmail("");
          setMessage("");
        } else {
          toast.error(response.data.error || "Failed to send email.");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while sending the email. Please try again.");
      }
    } else {
      toast.error("Please enter your name, email, and message to send an email.");
    }
  };
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;

  return (
    <>
      <LoadingSpinner state={loading} />

      <BalloonContainer
        show={
          parseInt(bday) === parseInt(day) &&
          parseInt(month) === parseInt(bmonth)
        }
        birthdayPerson={result.Name}
      />

      <div className="home-page">
        {/* navabar */}
        <Navbar
          collapseOnSelect
          expand="lg"
          className="navbar navbar-expand-sm bg-dark navbar-dark"
        >
          <Container>
            <Navbar.Brand href="#home" className="text-light">
              {result ? result.Name : "Loading..."}
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="text-white"
            />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto"></Nav>
              <Nav>
                <Nav.Link href="#projects" className="text-light">
                  Projects
                </Nav.Link>
                <Nav.Link href="#skills" className="text-light">
                  Skills
                </Nav.Link>
                <Nav.Link href="#experience" className="text-light">
                  Experience
                </Nav.Link>
                <Nav.Link href="#memes" className="text-light">
                  Contact
                </Nav.Link>
                
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <div className="theme darktheme">
          <button onClick={()=>setTheme("light")}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-brightness-high-fill" viewBox="0 0 16 16">
  <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
</svg></button>
        </div>
        
        {/* end of navbar */}

        {/* start of person details */}
        <section id="home">
          <div className="container col-xxl-8 px-4 py-5 ">
            <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
              <div className="col-10 col-sm-8 col-lg-6 text-center image-container">
                <ZoomInElement>
                  <img
                    src={result.Photo ? result.Photo : `./Profile.png`}
                    className="d-block mx-auto img-fluid square-image "
                    alt={result.Name}
                    loading="lazy"
                  />
                </ZoomInElement>
              </div>

              <div className="col-lg-6">
                <h1 className="display-6 fw-bold text-light lh-1 mb-3 ">
                  Hello, I'm{" "}
                  {result ? (
                    <div className="typewriter">
                      {" "}
                      <span className="gradient-text">{result.Name}</span>{" "}
                    </div>
                  ) : (
                    "Loading..."
                  )}
                  , and I enjoy crafting fantastic apps.
                </h1>
                <p className="lead text-light">
                  Detail-oriented college student with a strong enthusiasm for
                  acquiring hands-on experience and utilizing technical skills.
                  Eager to secure internship opportunities to further
                  professional growth and contribute to impactful projects.
                </p>
                <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                  {result && result.Resume && (
                    <button
                      type="button"
                      className="btn-lg px-4 me-md-2 hover-button"
                      onClick={() => openPdf(result && result.Resume)}
                    >
                      Resume
                    </button>
                  )}
                </div>
                {/* <br/> */}

                <div
                  className="d-flex gap-4 d-md-flex justify-content-md-start"
                  style={{ marginTop: "15px" }}
                >
                  {result && result.Instagram && (
                    <ZoomInElement>
                      <a
                        href={`https://instagram.com/${
                          result ? result.Instagram : ""
                        }`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="2em"
                          viewBox="0 0 448 512"
                          fill="white"
                        >
                          <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                        </svg>
                      </a>
                    </ZoomInElement>
                  )}{" "}
                  {result && result.Facebook && (
                    <ZoomInElement>
                      <a
                        href={`https://facebook.com/${
                          result ? result.Facebook : ""
                        }`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="2em"
                          viewBox="0 0 448 512"
                          fill="white"
                        >
                          <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
                        </svg>
                      </a>
                    </ZoomInElement>
                  )}
                  {result && result.Github && (
                    <ZoomInElement>
                      <a
                        href={`https://github.com/${
                          result ? result.Github : ""
                        }`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="2em"
                          viewBox="0 0 496 512"
                          fill="white"
                        >
                          <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                        </svg>
                      </a>
                    </ZoomInElement>
                  )}{" "}
                  {result && result.LinkedIn && (
                    <ZoomInElement>
                      <a
                        href={result ? result.LinkedIn : ""}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="2em"
                          viewBox="0 0 448 512"
                          fill="white"
                        >
                          <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                        </svg>
                      </a>
                    </ZoomInElement>
                  )}{" "}
                  {result && result.PhoneNumber && (
                    <ZoomInElement>
                      <a
                        href={`https://wa.me/91${result.PhoneNumber}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="2em"
                          viewBox="0 0 448 512"
                          fill="white"
                        >
                          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
                        </svg>
                      </a>
                    </ZoomInElement>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr style={{ color: "white" }} />

        <section
          id="projects"
          style={{
            minHeight: "100vh",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div className="px-3 py-4 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              height="2em"
              viewBox="0 0 640 512"
            >
              <path
                d="M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 
            0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 
            0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608
             0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
              />
            </svg>

            <h1 className="display-5 fw-bold text-light">Projects</h1>
            <div className="col-lg-6 mx-auto">
              <p className="lead mb-4 text-light">
                Discover a collection of my varied projects, encompassing web
                development and beyond. These endeavors demonstrate my
                abilities, imagination, and dedication to providing top-notch
                solutions. Whether it's responsive websites or inventive
                applications, each project narrates a distinct tale of
                problem-solving and exceptional work..
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-around flex-wrap ">
            {result?.Projects?.length > 0 ? (
              result.Projects.map(
                (project, index) =>
                  project.title !== "" && (
                    <div key={index}>
                      <FadeInElement>
                        <Card
                          style={{
                            width: "18rem",
                            marginBottom: "40px",
                            backgroundColor: "#16181b",
                            border: "2px  solid white",
                            minHeight: "90%",
                          }}
                        >
                          <Card.Img variant="top" src={"./project.jpg"} />

                          <Card.Body>
                            <Card.Title className="text-light">
                              {project.title}
                            </Card.Title>
                            <Card.Text className="text-light">
                              {expanded
                                ? project.description
                                : project.description.slice(0, 100)}
                              {project.description.length > 100 && (
                                <button
                                  variant="link"
                                  className="text-light btn btn-sm btn-link"
                                  onClick={() => setExpanded(!expanded)}
                                >
                                  {expanded ? "Show Less" : "Read More"}
                                </button>
                              )}
                            </Card.Text>
                            <a
                              href={project.link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <button className="hover-button">
                                View Project
                              </button>
                            </a>
                          </Card.Body>
                        </Card>
                      </FadeInElement>
                    </div>
                  )
              )
            ) : (
              <p className="text-light">No Projects available</p>
            )}
          </div>
        </section>
        <hr style={{ color: "white" }} />
        {/* end of project section */}
        {/* start of skill section */}
        <section
          id="skills"
          style={{
            minHeight: "100vh",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div className="px-0 py-2 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              height="2em"
              viewBox="0 0 512 512"
            >
              <path
                d="M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24
         24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24
          24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7
           24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7
            24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160
             128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192
              32H160V352H352V160z"
              />
            </svg>
            <h1 className="display-5 fw-bold text-light">
              Skills & Technologies
            </h1>
            <div className="col-lg-6 mx-auto">
              <p className="lead mb-4 text-light">
                Explore my wide range of skills and expertise in the latest
                technologies. From web development frameworks to programming
                languages, I possess a versatile skill set. These capabilities
                empower me to address various challenges, ensuring I am
                well-prepared to provide creative solutions and lead projects to
                successful outcomes.
              </p>
            </div>
          </div>
          {/* skills and languages started */}

          <div className="container-lg">
            <div className="row ">
              {result?.Skills?.length > 0 ? (
                result.Skills.map(
                  (skill, index) =>
                    skill !== "" && (
                      <div
                        className="col-lg-6 col-sm-12 col-12 mb-2 "
                        key={index}
                      >
                        <ZoomInElement>
                          <div className="bg-dark rounded p-5 d-flex align-items-center h-50">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="green"
                              aria-hidden="true"
                              style={{
                                width: "35px",
                                height: "35px",
                                marginRight: "8px",
                              }}
                            >
                              <path
                                fillRule="evenodd"
                                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                            <span
                              className=" text-white"
                              style={{ fontSize: "25px", marginLeft: "20px" }}
                            >
                              {skill}
                            </span>
                          </div>
                        </ZoomInElement>
                      </div>
                    )
                )
              ) : (
                <p className="text-light">No skills available</p>
              )}
            </div>
          </div>
        </section>
        <hr style={{ color: "white" }} />

        {/* skills and technologies ended */}
        {/* start of exprence and certificates */}
        <section
          id="experience"
          style={{
            minHeight: "100vh",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div className="px-3 py-4 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="2em"
              fill="white"
              viewBox="0 0 640 512"
            >
              <path d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z" />
            </svg>
            <h1 className="display-5 fw-bold text-light">
              Experience & Certifications
            </h1>
            <div className="col-lg-6 mx-auto">
              <p className="lead mb-4 text-light">
                Discover my technological journey and unwavering dedication to
                ongoing education. This section presents my professional
                endeavors, emphasizing the projects and positions that have
                influenced my career. Furthermore, you'll encounter
                certifications that affirm my competence and determination to
                remain current in this dynamic industry.
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-around flex-wrap ">
            {result?.Certifications?.length > 0 ? (
              result.Certifications.map(
                (certificate, index) =>
                  certificate.title !== "" && (
                    <div key={index}>
                      <FadeInElement>
                        <Card
                          style={{
                            width: "23rem",
                            marginBottom: "40px",
                            backgroundColor: "#16181b",
                            border: "2px  solid white",
                          }}
                        >
                          <Card.Img
                            variant="top"
                            src="./certificate.jpg"
                            style={{
                              width: "365px",
                            }}
                          />
                          <Card.Body>
                            <div
                              style={{
                                position: "absolute",
                                top: "28%",
                                left: "51%",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <Card.Title className="text-success h3">
                                {certificate.title.toUpperCase()}
                              </Card.Title>
                            </div>
                            <Card.Title className="text-light">
                              {certificate.title}
                            </Card.Title>
                            <Card.Text className="text-light">
                              {/* {certificate.description} */}
                              {expanded
                                ? certificate.description
                                : certificate.description.slice(0, 100)}
                              {certificate.description.length > 100 && (
                                <button
                                  variant="link"
                                  className="text-light btn btn-sm btn-link"
                                  onClick={() => setExpanded(!expanded)}
                                >
                                  {expanded ? "Show Less" : "Read More"}
                                </button>
                              )}
                            </Card.Text>
                            <a
                              href={certificate.link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <button className="hover-button">
                                Certificate Link
                              </button>
                            </a>
                          </Card.Body>
                        </Card>
                      </FadeInElement>
                    </div>
                  )
              )
            ) : (
              <p className="text-light">No Certifications available</p>
            )}
          </div>
        </section>

        <hr style={{ color: "white" }} />
        {/* certificates and exprence end */}
        <div className="hireme container pb-5 " id="memes">
          <div className="row">
            <div className="col-lg-6">
              {/* <iframe
                title="Google Maps"
                width="100%"
                min-width="300"
                height="90%"
                loading="lazy"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15298.646499975019!2d81.4779321567597!3d16.543171858762037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a362d5e7ef94f99%3A0x3a2b78f9b48493fe!2sSRKR%20Engineering%20College!5e0!3m2!1sen!2sin!4v1699555334680!5m2!1sen!2sin"
              ></iframe> */}
              <MapComponent address={result.Address} pincode={result.Pincode} />
            </div>
            <div className="col-lg-6">
              <div className="typewrite">
                <h1 className="text-light text-center">Hire Me </h1>
              </div>
              <p className="text-light">
                Are you open to collaboration? Reach out through the form below,
                and we can talk about your project. Whether you need a skilled
                developer, a creative thinker, or a tech-savvy partner, I'm here
                to assist in bringing your ideas to fruition. Share your needs,
                and together, let's work towards transforming your vision into
                reality.
              </p>
              <div className="mb-3">
                <label htmlFor="name" className="form-label text-light">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Your Name"
                  value={mname}
                  onChange={handleNameChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="mailId" className="form-label text-light">
                  Mail ID
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="mailId"
                  placeholder="name@example.com"
                  value={email}
                  onChange={handleEmailChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label text-light">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  rows="3"
                  placeholder="Your Message"
                  value={message}
                  onChange={handleMessageChange}
                ></textarea>
              </div>
              <div className="mb-3 text-center">
                <button
                  className=" btn btn-success text-center m-3"
                  onClick={SendMail}
                >
                  Hire Me
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};
